module.exports = __webpack_public_path__ + "img/close_small.9ce48295.svg";